// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxABb24L3y8HGT-MbXDejPQQeOvKbRGag",
  authDomain: "gathur-f030f.firebaseapp.com",
  projectId: "gathur-f030f",
  storageBucket: "gathur-f030f.firebasestorage.app",
  messagingSenderId: "606595663307",
  appId: "1:606595663307:web:9f30c6f1a0f7e54c6f224e",
  measurementId: "G-XQZ1HC7066"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment and if supported)
let analytics = null;
if (typeof window !== 'undefined') {
  // Check if Analytics is supported before initializing
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch(() => {
      // Silently fail - Analytics is optional and may not be available
      // (e.g., in private browsing mode or when IndexedDB is restricted)
    });
}

// Initialize Firestore
const db = getFirestore(app);

// Initialize Auth
const auth = getAuth(app);

// Initialize Storage
const storage = getStorage(app);

export { app, analytics, db, auth, storage };

